// Mock data for the Reptile Hisabbook landing page

export const BRAND = {
    name: "Reptile Hisabbook",
    tagline: "अब हिसाब रहेगा हमेशा डिजिटल",
    taglineEn: "India's Smart Digital Hisab Book",

    logoUrl: "/logo.png",
    whiteLogoUrl: "/white_logo.png",

    heroImageUrl:
        "/banner1.png",
};

export const CONTACT = {
    email: "info@reptileglobal.com",
    phone: "9310520960",
    phoneRaw: "+919310520960",
    whatsapp: "919310520960",
    address:
        "265, 2nd floor, Aggarwal City Plaza, Mangalam Place, Rohini, New Delhi, Delhi, 110085",
};

export const NAV_LINKS = [
    {label: "Features", href: "#features"},
    {label: "Benefits", href: "#benefits"},
    {label: "Video", href: "#video"},
    {label: "Pricing", href: "#pricing"},
    {label: "Contact", href: "#contact"},
];

export const FEATURES = [
    {
        id: "invoices",
        title: "Create Invoices & Manage Credit",
        desc: "Generate professional customer invoices and maintain accurate credit / loan records — without ever touching a paper diary.",
        icon: "FileText",
        accent: "teal",
        span: "md:col-span-2 md:row-span-2",
    },
    {
        id: "whatsapp",
        title: "Send Invoices on WhatsApp",
        desc: "1‑click delivery of invoices directly to your customer's WhatsApp.",
        icon: "MessageCircle",
        accent: "emerald",
        span: "md:col-span-1 md:row-span-1",
    },
    {
        id: "inventory",
        title: "Inventory Management",
        desc: "Track stock store‑wise and warehouse‑wise in real time.",
        icon: "Boxes",
        accent: "orange",
        span: "md:col-span-1 md:row-span-2",
    },
    {
        id: "cash",
        title: "Daily Sales Cash",
        desc: "Verify your evening cash collection in seconds.",
        icon: "IndianRupee",
        accent: "teal",
        span: "md:col-span-1 md:row-span-1",
    },
    {
        id: "reminders",
        title: "Auto SMS & WhatsApp Reminders",
        desc: "Send polite payment reminders that actually get paid.",
        icon: "BellRing",
        accent: "emerald",
        span: "md:col-span-1 md:row-span-1",
    },
    {
        id: "fines",
        title: "Fines, Penalties & Full Finance Control",
        desc: "Manage every financial record and auto‑apply late fees / fines when required.",
        icon: "ShieldAlert",
        accent: "orange",
        span: "md:col-span-2 md:row-span-1",
    },
    {
        id: "resend",
        title: "Search & Resend Lost Invoices",
        desc: "Customer lost an invoice? Search by name, mobile or serial — resend on WhatsApp in 1 click.",
        icon: "Search",
        accent: "teal",
        span: "md:col-span-2 md:row-span-1",
    },
    {
        id: "emi",
        title: "EMI & Credit Tracking",
        desc: "Stay on top of every EMI installment and credit account, securely.",
        icon: "CreditCard",
        accent: "emerald",
        span: "md:col-span-1 md:row-span-1",
    },
];

export const BENEFITS = [
    {
        title: "100% Secure & Private",
        desc: "Bank‑grade encryption. Automatic cloud backups. Your hisab is safer than a locked diary.",
        image:
            "/image1.png",
        bullets: [
            "End‑to‑end encrypted records",
            "Daily automatic backups",
            "Role‑based staff access",
        ],
    },
    {
        title: "Grow Your Business",
        desc: "Stop wasting hours on manual calculations. Spend that time selling more, recovering more, growing more.",
        image:
            "/image2.png",
        bullets: [
            "Real‑time dashboards",
            "Faster recovery via auto reminders",
            "Smarter inventory decisions",
        ],
    },
];

export const TRUST_STRIP = [
    {label: "100% Secure", desc: "Your data is safe with us", icon: "ShieldCheck"},
    {label: "Save Time", desc: "Automate daily business tasks", icon: "Clock"},
    {label: "Grow Business", desc: "Better tracking, better growth", icon: "TrendingUp"},
    {label: "Easy to Use", desc: "Simple, fast & user friendly", icon: "Smartphone"},
];

const ALL_FEATURES = [
    "Unlimited customer invoices",
    "Credit / loan / EMI tracking",
    "Inventory: store & warehouse‑wise",
    "WhatsApp & SMS reminders",
    "1‑click WhatsApp invoice send",
    "Daily sales cash report",
    "Fines & penalties module",
    "Search & resend lost invoices",
    "Cloud backup & multi‑device sync",
    "Priority customer support",
];

export const PLANS = [
    {
        id: "monthly",
        name: "Monthly",
        price: "₹399",
        period: "/month",
        note: "Try it out, cancel anytime",
        features: ALL_FEATURES,
        highlight: false,
        badge: null,
        cta: "Choose Monthly",
    },
    {
        id: "yearly",
        name: "Yearly",
        price: "₹2,999",
        period: "/year",
        note: "Best value — 2+ months free",
        features: ALL_FEATURES,
        highlight: true,
        badge: "Most Popular",
        cta: "Choose Yearly",
    },
    {
        id: "halfyearly",
        name: "Half‑Yearly",
        price: "₹1,799",
        period: "/6 months",
        note: "Save vs. monthly",
        features: ALL_FEATURES,
        highlight: false,
        badge: null,
        cta: "Choose Half‑Yearly",
    },
];

export const FAQS = [
    {
        q: "Does every plan get all features?",
        a: "Yes — every plan (Monthly, Half‑Yearly, Yearly) includes 100% of the features. Only the billing period and price differ.",
    },
    {
        q: "Can I switch plans later?",
        a: "Absolutely. Upgrade or change billing cycle anytime from inside the app or by contacting our support team.",
    },
    {
        q: "Is my financial data safe?",
        a: "Your data is encrypted and backed up automatically. Only you and the staff you authorise can access it.",
    },
    {
        q: "Do I need internet to use the app?",
        a: "You can record entries offline; they sync the moment you're back online. WhatsApp & SMS features require connectivity.",
    },
];
